import { useEffect, useRef, useState } from "react";

/**
 * Anti-bot hook: exposes
 *  - hpProps: spread onto a hidden honeypot <input>
 *  - hpValue / setHp: to include in payload
 *  - startedAt: client timestamp (ms) when the form was mounted
 */
export const useAntiBot = () => {
  const [hp, setHp] = useState("");
  const startedAt = useRef(Date.now());

  useEffect(() => {
    startedAt.current = Date.now();
  }, []);

  return {
    hp,
    setHp,
    startedAt: startedAt.current,
    honeypotProps: {
      type: "text",
      name: "website",
      tabIndex: -1,
      autoComplete: "off",
      value: hp,
      onChange: (e) => setHp(e.target.value),
      "aria-hidden": true,
      style: {
        position: "absolute",
        left: "-10000px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
        opacity: 0,
        pointerEvents: "none",
      },
    },
  };
};
